
import React, { Fragment } from "react";
import { FailurePanel } from "components/notifications/FailurePanel";

export function LicenceCheckingConsentReject() {
    return (
        <Fragment>
                <h2>Driver Declaration Submitted</h2>
                <FailurePanel title="Refused Driver Declaration">
                    <p>
                        You have decided to reject your Driver Declaration. <br />
                        You may now close this window.
                    </p>
                </FailurePanel>
        </Fragment>
    );
}
